import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ResolvableModal } from '@softline/ui-core';
import { PickingOrderComponent } from '../../components/picking-order/picking-order.component';
import { KommissionsauftragKopf } from '../../types/kommissionsauftrag';

@Component({
  selector: 'soft-select-kopfkomm-modal',
  imports: [PickingOrderComponent],
  templateUrl: './select-kopfkomm-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectKopfkommModal extends ResolvableModal<KommissionsauftragKopf> {
  readonly orders = input<KommissionsauftragKopf[]>([]);

  onSelect(order: KommissionsauftragKopf): void {
    this.resolve(order);
  }
}
